<template>
  <v-card>
    <popup-form
      v-on:close="close"
      :canDelete="false"
      :title="'Transfer'"
      :buttonTitle="'Submit'"
      v-on:submit="submit"
    >
      <template slot>
        <v-container class="px-2 py-4">
          <v-select
            :items="locations"
            item-text="name"
            outlined
            filled
            hide-details
            v-model="location"
            label="Transfer Location"
            return-object
          >
          </v-select>
        </v-container>
      </template>
    </popup-form>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    type: String
  },
  data() {
    return {
      location: null
    };
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    locations() {
      return this.account.locations.filter(l => {
        return l != this.account.location;
      });
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      this.$emit('transfer', this.location._id);
    }
  }
};
</script>
